<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style>
    @import '~bootstrap/dist/css/bootstrap.css';
    @import '~bootstrap-icons/font/bootstrap-icons.css';
    @import '~global/assets/styles/style.css';
</style>
